// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - sanitize-html lacks type definitions
import sanitizeHtml from 'sanitize-html';

type SanitizeHtmlOptions = {
	allowedTags: string[];
	allowedAttributes: Record<string, string[]>;
	allowedSchemes: string[];
};

const MAIL_SANITIZE_CONFIG: SanitizeHtmlOptions = {
	allowedTags: [
		'p', 'div', 'span', 'br', 'hr',
		'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
		'strong', 'em', 'b', 'i', 'u', 's',
		'ul', 'ol', 'li',
		'table', 'thead', 'tbody', 'tr', 'td', 'th',
		'a', 'img',
		'blockquote', 'pre', 'code', 'center', 'font'
	],
	allowedAttributes: {
		a: ['href', 'target', 'rel'],
		img: ['src', 'alt', 'width', 'height'],
		'*': ['style', 'class', 'align', 'valign', 'bgcolor', 'border', 'cellpadding', 'cellspacing', 'color', 'face', 'size']
	},
	allowedSchemes: ['http', 'https', 'mailto', 'tel']
};

export const sanitizeMailHtml = (html: string): string => {
	return sanitizeHtml(html || '', MAIL_SANITIZE_CONFIG);
};
